import { LinearProgress } from "@mui/material";
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";

interface DBLoadingPageProps {
  isDone: boolean;
  onDone: () => void;
}

const DBLoadingPage = (props: DBLoadingPageProps) => {
  const { isDone, onDone } = props;

  const { t } = useTranslation();

  const [progress, setProgress] = React.useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setProgress((oldProgress) => {
        if (isDone) {
          clearInterval(timer);
          return 100;
        }

        if (oldProgress >= 75) {
          return 85;
        }

        const diff = Math.random() * 2;
        return Math.min(oldProgress + Math.round(diff), 100);
      });
    }, 500);
    return () => {
      clearInterval(timer);
    };
  }, [isDone, progress]);

  if (progress === 100) {
    setTimeout(onDone, 1000);
  }

  return (
    <div className="dui-db-loading">
      <div className="dui-db-loading-form">
        <div className="dui-first-login-logo">
          <b>Doktor</b>UI
        </div>
        <div className="dui-db-loading-title">{t("initializingAccount")}</div>
        <div className="dui-db-loading-subtitle">({t("mayTakeSomeTime")})</div>
        <div className="dui-db-loading-progress-wrapper">
          <LinearProgress
            variant="determinate"
            value={progress}
            className="dui-db-loading-progress"
          ></LinearProgress>
          {progress === 100 ? (
            <div className="dui-db-loading-progress-text">{t("finished")}!</div>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default DBLoadingPage;
